import { useMemorandumLogo } from "hooks/MemorandumLogo";
import { selectState } from "../outputSlice";
import { useSelector } from "react-redux";
import { FormatDateShort, GetTodayDate } from "utils/dateUtils";
import "../../Input/print.scss";
import { FormatNumber, FormatNumberWithUnitOrNull } from "utils/numberUtils";
import { IOutputListItem } from "Dashboard/scenes/Stock/domain/IOutputListItem";

const PrintStateOfOutput = () => {
  const memorandumLogo = useMemorandumLogo();
  const { outputListItems, totalCost: totalPrice, totalQuantityAmount } = useSelector(selectState);

  const whereOnBill = (outputListItem: IOutputListItem) => outputListItem.partner
    ? outputListItem.partner.fullName
    : outputListItem.projectOverride
      ? outputListItem.projectOverride.projectName
      : outputListItem.project ? outputListItem.project.projectName : "";

  return (
    <div className="lager-page">
      <div className="stock-output-header-container">
        <div className="logo">
          {memorandumLogo && <img src={memorandumLogo} alt="" />}
        </div>
        <div>
          <h1 className="stock-output-header">Lager - IZLAZ</h1>
        </div>
        <div className="date">{GetTodayDate()}</div>

      </div>
      <table className="table-header stock-output-header stock-output-size">
        <tbody>
          <tr>
            <th>br.otp.rač</th>
            <th className="name">ime</th>
            <th>projekat</th>
            <th>kol izdato</th>
            <th>cena</th>
            <th>datum</th>
          </tr>
        </tbody>
      </table>
      <table className="table-body stock-output-size stock-output">
        <tbody>
          {outputListItems.map((outputListItem, itemIndex) =>
            <tr key={outputListItem.outputItemId}>
              <td>
                <label className="check"></label>
                <label>{outputListItem.billOfLandingId}</label>
              </td>
              <td>
                <div className="name-container">
                  <div>
                    <label className="name">{outputListItem.name}</label>
                    <label className="supplier">{outputListItem.supplier}</label>
                  </div>
                  <label className="badge">
                    {outputListItem.repository.shortName}
                  </label>
                </div>
              </td>
              <td className="destination-cell">
                <div>
                  <label className="destination">{whereOnBill(outputListItem)}</label>
                  <label className="taken-away-by">{outputListItem.quantityAmount > 0 ? outputListItem.takenAwayByDriverAndVehicle : ""}</label>
                </div>
              </td>
              <td>
                <div>
                  <label>
                    <b>{FormatNumber(outputListItem.quantityAmount)}</b>
                    {outputListItem.unit.name}
                  </label>
                </div>
              </td>
              <td>
                <label>{FormatNumber(outputListItem.totalCost)}</label>
              </td>
              <td>{FormatDateShort(outputListItem.date)}</td>
            </tr>
          )}
        </tbody>
        <tfoot>
          <tr className="footer">
            <td></td>
            <td></td>
            <td>ukupno</td>
            <td>
              <label>{FormatNumber(totalQuantityAmount)}</label>
            </td>
            <td colSpan={2}>
              <label>{FormatNumberWithUnitOrNull(totalPrice, 'rsd')}</label>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
};

export default PrintStateOfOutput;
